<template>
  <div class="flex flex-col items-center justify-center min-h-screen px-6 py-8 mx-auto lg:py-0">
      <div class="w-full bg-white rounded-lg shadow dark:border sm:max-w-md dark:bg-gray-800 dark:border-gray-700">
          <div class="p-6 space-y-4 sm:space-y-6">
              <h1 class="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white text-center">
                  Sign in to your account
              </h1>
              <v-form class="space-y-4 sm:space-y-6" @submit.prevent="login">
                  <div>
                      <label for="username" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Username</label>
                      <input variant="underlined" v-model="input.username" :rules="usernameRules" type="text" name="username" id="username" class="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="product_manager_01@company.com">
                  </div>
                  <div>
                      <label for="password" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Password</label>
                      <input variant="underlined" v-model="input.password" :rules="passwordRules" type='password' name="password" id="password" placeholder="••••••••" class="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                  </div>
                  <!-- Alert Section -->
                  <div v-if="responseMessage !== ''"  class="flex items-center p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400" role="alert">
                    <svg class="flex-shrink-0 inline w-4 h-4 me-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
                    </svg>
                    <span class="sr-only">Info</span>
                    <div>
                      <span class="font-medium">Login Failed!</span> {{ responseMessage }}.
                    </div>
                  </div>
                  <!-- End Alert Section -->
                  <div class="flex items-center justify-between">
                      <div class="flex items-start">
                          <div class="flex items-center h-5">
                              <input id="remember" aria-describedby="remember" type="checkbox" class="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-primary-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-primary-600 dark:ring-offset-gray-800" required>
                          </div>
                          <div class="ml-3 text-sm">
                              <label for="remember" class="text-gray-500 dark:text-gray-300">Remember me</label>
                          </div>
                      </div>
                      <a href="#" class="text-sm font-medium text-primary-600 hover:underline dark:text-primary-500">Forgot password?</a>
                  </div>
                  <button type="submit" class="w-full px-4 py-2 text-white bg-indigo-600 rounded-md hover:bg-indigo-700">Sign in</button>
                  <p class="text-sm font-light text-gray-500 dark:text-gray-400">
                      Don’t have an account yet? <a href="#" class="font-medium text-primary-600 hover:underline dark:text-primary-500">Sign up</a>
                  </p>
              </v-form>
          </div>
      </div>
  </div>
</template>

<script>

import axios from "axios";
import store from '../store';
export default {
  data() {
    return {
      input: {
        username: "",
        password: "",
      },
      showAlert: false,
      responseMessage: '',
      alertClass: '',
      usernameRules: [(v) => !!v || 'Username is required'],
      passwordRules: [(v) => !!v || 'Password is required'],
      // usernameRules: [
      //   (value) => {
      //     if (value?.length > 0) return true;

      //     return "Username is required.";
      //   },
      // ],
      // passwordRules: [
      //   (value) => {
      //     if (value?.length > 0) return true;

      //     return "Password is required.";
      //   },
      // ],
      showModal: false,
    };
  },
  methods: {
    async login() {
      this.responseMessage = '';
      this.showAlert = false;
      if (this.input.username.length > 0 && this.input.password.length > 0)
        try {
          const response = await axios.post(
            process.env.VUE_APP_BASE_API + "/api/login/checklogin",
            {
              username: this.input.username,
              password: this.input.password,
            }
          );
          // console.log(JSON.stringify(response.data))
          if (response.data && response.data.data) {
            // localStorage.setItem('username', response.data.username);
            store.dispatch(`login`, response.data.data);
            const loginRole = store.getters.role;
            if(loginRole === "admin"){
              this.$router.push("/sale/dashboard").then(() => {
                window.location.reload();
              });
            }else if(loginRole === "pm"){
              this.$router.push("/productMaster/dashboard").then(() => {
                window.location.reload();
              });
            }else if(loginRole === "sale"){
              this.$router.push("/sale/dashboard").then(() => {
                window.location.reload();
              });
            }else if(loginRole === "cs"){
              this.$router.push("/cs/searchproducts").then(() => {
                window.location.reload();
              });
            }else{
              this.responseMessage = 'Login successful';
              this.alertClass = 'p-4 mb-4 text-sm text-green-700 bg-green-100 rounded-lg dark:bg-green-200 dark:text-green-800';
              this.showAlert = true;
            }
          } else {
            this.responseMessage = 'Invalid username or password';
            this.alertClass = 'p-4 mb-4 text-sm text-green-700 bg-red-100 rounded-lg dark:bg-green-200 dark:text-green-800';
            this.showAlert = true;
          }
        } catch (error) {
          console.error("Login error:", error);
            this.responseMessage = 'Invalid username or password';
            this.alertClass = 'p-4 mb-4 text-sm text-green-700 bg-red-100 rounded-lg dark:bg-green-200 dark:text-green-800';
            this.showAlert = true;
        }
    },
    closeModal() {
      this.showModal = false;
    }
  },
};
</script>

<style>
/* Add any custom styles here */
</style>
